import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportCryptoAddressWatchlist } from 'dashboard/models/report/crypto-address-watchlist';
import { ReportTemplate } from 'dashboard/models/report-template';

interface CryptoAddressWatchlistProps {
  report: ReportCryptoAddressWatchlist;
  reportTemplate?: ReportTemplate;
  isRedacted: boolean;
}

export const CryptoAddressWatchlist = ({
  report: {
    attributes: { query: cryptoAddress },
  },
  isRedacted,
}: CryptoAddressWatchlistProps) => {
  return (
    <AttributeGrid>
      {cryptoAddress && (
        <AttributeItem
          title='Crypto Address'
          value={cryptoAddress['crypto-address']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-crypto-address-watchlist__crypto-address-watchlist'
        />
      )}
    </AttributeGrid>
  );
};
